import keyBy from 'lodash/keyBy';
import flatten from 'lodash/flatten';

import { createSelector } from 'reselect';

const getRawConfigName = (state, name) => state.config[name];
const getRawAttributes = (state) => state.config?.data?.attributes;

export const getConfigByName = createSelector(
  [getRawConfigName],
  (config) => config || [],
);

export const getAttributesKeyById = createSelector([getRawAttributes], (data) =>
  keyBy(data, 'id'),
);

export const getProductAttributesObjKeyById = createSelector(
  [getRawAttributes],
  (data) => keyBy(flatten(data?.map?.((attribute) => attribute?.values)), 'id'),
);
